import TagManager from 'react-gtm-module';
import { APP_ENV, GTM_ID } from '../config';
import { loadScript } from './loadScript';
import { initMixpanel } from './mixpanel';

// ==== Mouseflow ====
export async function loadMouseflow() {
  await loadScript(`//cdn.mouseflow.com/projects/aa624a5b-863f-4e42-9ae0-a5f1fc92f2f4.js`, { defer: true });
}

// ==== New Relic Browser ====
export async function loadNewRelicBrowser() {
  if (APP_ENV !== 'production') return;
  await loadScript(`${process.env.PUBLIC_URL}/newrelic.js`);
}

// ==== Mixpanel ====
export async function loadMixpanel() {
  initMixpanel();
}

// ==== GA ====
export async function loadGoogleAnalytics() {
  const tagManagerArgs = {
    gtmId: GTM_ID
  };
  TagManager.initialize(tagManagerArgs);
}